import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, of } from 'rxjs';
import { map, first, catchError } from 'rxjs/operators';
import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';

@Injectable({
  providedIn: 'root'
})
export class SpecialtiesService {
  private specialties = new ReplaySubject<any>(1);
  private specialtiesPicker = new ReplaySubject<any>(1);

  constructor(private cms: ACResourceService) { }

  public updateSpecialties = (params: any) => {
    var path = `/contact/specialty-list`
    return this.cms.request('GET', path, params).pipe(
      first(),
      map(data => {
        this.specialties.next(data)
        return data
      })
    )
  }

  public getSpecialties = (): Observable<any> => {
    return this.specialties.asObservable()
  }

  public updateSpecialtiesPicker = (params: any) => {
    var path = `/contact/specialty-list`
    return this.cms.request('GET', path, params).pipe(
      first(),
      map(body => {
        this.specialtiesPicker.next(body.data)
        return body.data
      }),
      catchError(err => {
        this.specialtiesPicker.next([])
        return of([])
      })
    )
  }

  public getSpecialtiesPicker = (): Observable<any> => {
    return this.specialtiesPicker.asObservable()
  }

}
